import { createFileRoute } from '@tanstack/react-router';
import { ChainCoveragePage } from '@/pages/chain/coverage/ChainCoveragePage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

function ChainCoverage() {
	return <ChainCoveragePage />;
}

export const Route = createFileRoute('/_authenticated/_app/chain/coverage')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainHq.read', 'chainHq.readAnalytics'], redirectTo: '/dashboard' }),
	component: ChainCoverage,
});
